import { LOAD_USER_SUCCESS } from '../ActionType';
export var loadUser = function(user) {
    return function(dispatch) {
        return dispatch({
            type: LOAD_USER_SUCCESS,
            payload: {
                user: user
            }
        });
    };
};
